import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Accordion, Banner, LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import api, { parseErrors } from 'util/api';
import useDevicesStore from 'store/devices';


function RtdAssignment({ device }) {
  const [devicesStore] = useDevicesStore();
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [availableRtds, setAvailableRtds] = useState([]);
  const [existingMappings, setExistingMappings] = useState([]);
  const [error, setError] = useState();
  const [success, setSuccess] = useState([]);

  // Steam controllers only have one circuit by the nature of their design
  // This function grabs that circuit ID for the mapping calls
  // In the future, if we support more complex devices, this will need to be updated
  function getCircuitId() {
    return devicesStore.shallowDevices.get(device.id)?.model?.children[0]?.id;
  }

  function queryRtdInfo() {
    setLoading(true);
    api(`/devices/${device.id}/virtualCircuitMappings`)
      .then(async res => {
        const data = await res.json();
        setAvailableRtds(data.availableRtdPods || []);
        setExistingMappings(data.existingMappings || []);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function toggleRtd(checked, rtd) {
    let promise;
    setProcessing(true);

    if (checked) {
      promise = api(`/devices/${getCircuitId()}/mapRTD`, {
        method: 'PUT',
        body: JSON.stringify({
          sensorId: rtd.sensorId,
          sensorIndex: rtd.index,
          id: device.id
        })
      });
    } else {
      promise = api(`/devices/${getCircuitId()}/removeRTD`, {
        method: 'PUT',
        body: JSON.stringify({
          sensorId: rtd.sensorId,
          id: device.id
        })
      });
    }

    promise
      .then(async res => {
        queryRtdInfo();
        setSuccess(current => [...new Set([...current, rtd.sensorId])]);
        setTimeout(() => {
          setSuccess(current => current.filter(sensorId => sensorId !== rtd.sensorId));
        }, 3000);
      })
      .catch(async err => {
        setError(parseErrors(await err.json()));
        setTimeout(() => setError(null), 5000);
      })
      .finally(() => {
        setProcessing(false);
      });

    return promise;
  }

  useEffect(() => {
    queryRtdInfo();
  }, [device]);

  return (<>
    <div className="configuration-section">
      <h4><Trans>Select RTDs</Trans></h4>
      <ul className="form">
        {availableRtds?.length ? availableRtds.map((pod, pIdx) => (
          <Accordion key={`pod-${pIdx}`} header={pod.name} maxHeight={300}>
            <Banner show={error} status="alert" small={true}>{error}</Banner>
            <ul className="rtd-pod">
              {pod.dtms?.map((dtm, dIdx) => (
                <li key={`dtm-${pIdx}-${dIdx}`}>
                  <label>{dtm.name}</label>
                  <ul className="rtd-list">
                    {dtm.rtds?.map(rtd => {
                      return (
                        <li key={rtd.sensorId}>
                          <label>
                            <input
                              type="checkbox"
                              checked={existingMappings.some(mapping => mapping.rtdId === rtd.sensorId)}
                              value={rtd.sensorId}
                              onChange={event => toggleRtd(event.target.checked, rtd)}
                              disabled={processing}
                            />
                            {rtd.name}
                            {success.includes(rtd.sensorId) ?
                              <span className="status-icon success"><Trans>Success</Trans></span>
                            : null}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              ))}
            </ul>
          </Accordion>
        )) :
          <>{loading ? <LoadingIndicator show={true}/> : <p><Trans>No RTDs found</Trans></p>}</>
        }
      </ul>
    </div>
  </>)
}

export default RtdAssignment;
